import {
  BankOutlined,
  CalculatorOutlined,
  ControlOutlined,
  DashboardOutlined,
  DeliveredProcedureOutlined,
  GiftOutlined,
  GoldOutlined,
  LayoutOutlined,
  MedicineBoxOutlined,
  NodeIndexOutlined,
  PayCircleOutlined,
  RadarChartOutlined,
  SafetyCertificateOutlined,
  SearchOutlined,
  SettingOutlined,
  SmileOutlined,
  TagsOutlined,
  TeamOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { LiaUserNurseSolid, LiaHospitalSolid } from "react-icons/lia";
import {
  FaUsersBetweenLines,
  FaStethoscope,
  FaUserDoctor,
} from "react-icons/fa6";
import {
  MdPersonAddAlt1,
  MdOutlineMenuBook,
  MdMonitorHeart,
} from "react-icons/md";
import { RiHospitalLine, RiDiscountPercentLine } from "react-icons/ri";
import { TbTemplate } from "react-icons/tb";
import { FaMicroscope } from "react-icons/fa";
import { TbLayoutDashboard } from "react-icons/tb";
import { FaBed } from "react-icons/fa";
import { TbReportSearch } from "react-icons/tb";
import { MdOutlineLocalPharmacy } from "react-icons/md";
import { HiCreditCard } from "react-icons/hi2";
import { BsCalendarCheck } from "react-icons/bs";

export const MENU = {
  MdPersonAddAlt1: <MdPersonAddAlt1 />,
  FaUsersBetweenLines: <FaUsersBetweenLines />,
  SettingOutlinedSpin: <SettingOutlined spin rotate={5} />,
  LiaHospitalSolid: <LiaHospitalSolid />,
  MdOutlineMenuBook: <MdOutlineMenuBook />,
  FaStethoscope: <FaStethoscope />,
  RiDiscountPercentLine: <RiDiscountPercentLine />,
  FaUserDoctor: <FaUserDoctor />,
  MdMonitorHeart: <MdMonitorHeart />,
  TbTemplate: <TbTemplate />,
  FaMicroscope: <FaMicroscope />,
  TbLayoutDashboard: <TbLayoutDashboard />,
  FaBed: <FaBed />,
  TbReportSearch: <TbReportSearch />,
  MdOutlineLocalPharmacy: <MdOutlineLocalPharmacy />,
  HiCreditCard: <HiCreditCard />,
  BsCalendarCheck: <BsCalendarCheck />,
  ControlOutlined: <ControlOutlined />,
  DeliveredProcedureOutlined: <DeliveredProcedureOutlined />,
  SearchOutlined: <SearchOutlined />,
  GiftOutlined: <GiftOutlined />,
  CalculatorOutlinedSpin: <CalculatorOutlined spin rotate={180} />,
  CalculatorOutlined: <CalculatorOutlined />,
  SafetyCertificateOutlined: <SafetyCertificateOutlined />,
  LiaUserNurseSolid: <LiaUserNurseSolid />,
  ProcurementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width="1em"
      height="1em"
      fill="currentColor"
      style={{ verticalAlign: "middle" }}
    >
      <g transform="translate(0,512) scale(0.1,-0.1)">
        <path d="M2031 5059 c-300 -59 -547 -297 -617 -597 -23 -97 -21 -267 5 -364 38 -148 113 -271 229 -379 111 -104 235 -167 384 -197 l78 -15 0 -44 0 -43 -540 0 -540 0 0 375 c0 427 -2 441 -82 522 -78 80 -97 83 -499 83 -387 0 -391 -1 -429 -63 -17 -28 -20 -51 -20 -172 0 -121 3 -144 20 -172 33 -56 43 -58 315 -63 l250 -5 5 -1722 5 -1722 21 -28 c11 -15 36 -38 54 -51 32 -21 40 -22 275 -22 l243 0 7 -37 c19 -107 96 -210 192 -259 52 -26 68 -29 153 -29 83 0 102 3 150 27 97 48 167 137 191 245 l12 53 102 0 c116 0 135 10 135 72 0 60 -24 72 -155 77 l-113 3 -13 30 c-18 44 -97 121 -151 146 -25 13 -73 28 -106 34 -126 23 -267 -40 -340 -153 l-37 -58 -92 0 -93 -1 0 165 0 165 1970 0 1970 0 0 -165 0 -165 -278 0 -277 0 -24 46 c-77 145 -282 211 -436 141 -66 -31 -135 -92 -167 -149 l-21 -37 -693 -3 c-664 -3 -693 -4 -713 -22 -27 -25 -29 -86 -3 -109 17 -16 80 -17 699 -17 l681 0 11 -52 c23 -107 96 -199 199 -249 39 -20 63 -24 142 -24 112 0 161 18 234 85 59 54 86 98 106 174 l17 61 299 5 c208 3 305 9 320 17 47 27 54 65 54 298 0 311 -3 315 -219 315 l-130 0 -3 204 c-3 184 -5 206 -22 225 -24 27 -86 29 -109 3 -14 -15 -17 -50 -19 -223 l-3 -204 -697 -3 -698 -2 0 110 0 110 68 0 c226 1 439 138 548 353 l24 47 241 0 c195 0 245 3 269 15 57 29 60 48 60 340 l0 265 95 0 95 0 0 -268 c0 -305 2 -312 69 -312 26 0 44 7 57 21 18 19 19 42 22 288 4 311 1 341 -38 384 l-28 32 -134 5 -133 5 -5 1077 -5 1078 -33 32 -32 33 -739 3 -739 2 -21 35 c-24 41 -63 54 -100 34 -45 -25 -48 -59 -14 -136 61 -137 76 -261 47 -401 -59 -291 -319 -502 -618 -502 -175 0 -316 59 -441 185 -130 130 -186 265 -186 450 0 176 59 316 190 445 196 195 487 236 739 105 77 -39 111 -40 137 -2 39 56 4 106 -113 159 -132 60 -332 84 -471 57z m2249 -709 l0 -130 -658 0 -659 0 -7 103 c-3 56 -9 114 -12 130 l-6 27 671 0 671 0 0 -130z m-3463 -120 c68 -41 63 111 63 -1890 l0 -1810 -70 0 -70 0 -2 1751 -3 1751 -28 24 -28 24 -265 0 -264 0 0 85 0 85 318 0 c297 0 319 -1 349 -20z m3463 -1305 l0 -1145 -193 0 -194 0 0 79 c-4 349 -305 630 -653 608 -324 -21 -578 -281 -583 -599 l-2 -88 -197 0 -198 0 0 865 0 865 23 4 c136 28 216 57 292 105 l40 26 398 5 399 5 19 24 c25 30 24 62 -2 95 l-20 26 -310 0 -310 0 31 45 c32 46 93 169 103 205 5 20 8 20 681 20 l676 0 0 -1145z m-2900 179 l0 -166 29 -29 29 -29 232 0 232 0 29 29 29 29 0 166 0 166 75 0 75 0 0 -435 0 -435 -540 0 -540 0 0 435 0 435 175 0 175 0 0 -166z m430 46 l0 -120 -140 0 -140 0 0 120 0 120 140 0 140 0 0 -120z m1575 -845 c186 -49 332 -210 354 -391 34 -288 -179 -534 -464 -534 -296 0 -521 272 -461 558 55 263 318 432 571 367z m-1683 -251 l3 -196 33 -29 32 -29 169 0 168 0 7 -48 c3 -26 13 -58 22 -70 33 -48 56 -52 313 -52 l240 0 36 -69 c64 -121 179 -229 300 -281 l46 -20 -3 -122 -3 -123 -1017 -3 -1018 -2 0 620 0 620 334 0 335 0 3 -196z m408 46 l0 -150 -130 0 -130 0 0 150 0 150 130 0 130 0 0 -150z m-521 -1510 c56 -16 100 -52 126 -104 68 -137 -25 -287 -177 -286 -129 1 -225 130 -189 252 16 52 75 115 126 133 48 17 70 18 114 5z m2610 -28 c80 -49 112 -152 76 -240 -35 -83 -107 -126 -197 -120 -169 12 -246 206 -130 330 69 73 164 84 251 30z" />
        <path d="M3820 3780 c-12 -12 -20 -33 -20 -54 0 -48 37 -76 101 -76 59 0 93 15 108 47 16 34 14 47 -10 77 -19 24 -27 26 -90 26 -56 0 -73 -4 -89 -20z" />
        <path d="M2551 3444 c-26 -33 -27 -65 -2 -95 l19 -24 689 -3 c732 -3 736 -2 754 45 14 37 11 52 -16 78 l-24 25 -700 0 -700 0 -20 -26z" />
        <path d="M2555 3115 c-14 -13 -25 -36 -25 -50 0 -14 11 -37 25 -50 24 -25 26 -25 214 -25 120 0 199 4 215 11 51 23 55 103 7 128 -12 7 -97 11 -216 11 -195 0 -196 0 -220 -25z" />
        <path d="M3137 3129 c-46 -27 -41 -105 9 -128 17 -7 149 -11 423 -11 443 0 434 -1 447 67 5 26 1 37 -19 57 l-26 26 -408 0 c-266 -1 -414 -4 -426 -11z" />
        <path d="M2555 2785 c-14 -13 -25 -36 -25 -50 0 -14 11 -37 25 -50 l24 -25 696 0 696 0 24 25 c14 13 25 36 25 50 0 14 -11 37 -25 50 l-24 25 -696 0 -696 0 -24 -25z" />
        <path d="M3361 1925 l-127 -124 -89 89 c-94 95 -118 106 -162 75 -28 -20 -37 -59 -19 -93 8 -15 66 -78 129 -139 155 -153 138 -155 330 35 168 166 185 189 166 233 -14 34 -36 49 -74 49 -21 0 -56 -28 -154 -125z" />
        <path d="M2121 4724 c-12 -15 -21 -37 -21 -50 0 -20 -5 -24 -33 -24 -209 0 -314 -244 -162 -378 60 -52 103 -62 283 -62 132 0 151 -2 165 -18 25 -28 21 -67 -9 -91 -25 -19 -40 -21 -205 -21 -166 0 -180 -1 -199 -20 -25 -25 -26 -71 -1 -101 16 -19 30 -24 90 -27 66 -4 71 -6 71 -27 0 -12 9 -34 21 -49 41 -52 129 -23 129 43 0 27 2 28 60 34 68 6 137 41 168 85 80 114 41 266 -83 323 -34 16 -66 19 -203 19 -159 0 -163 1 -187 25 -14 13 -25 34 -25 45 0 12 11 32 25 45 24 25 26 25 205 25 167 0 181 1 200 20 30 30 27 83 -6 109 -21 16 -41 21 -90 21 l-64 0 0 30 c0 67 -88 96 -129 44z" />
      </g>
    </svg>
  ),
  PharmacyIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="1em"
      height="1em"
      fill="currentColor"
      style={{ verticalAlign: "middle" }}
    >
      <g transform="translate(0,50) scale(0.1,-0.1)">
        <path d="M130 399 c-109 -86 -143 -120 -106 -106 14 6 16 -8 16 -128 l0 -135 210 0 210 0 0 135 c0 120 2 134 16 128 38 -14 3 21 -106 106 -63 50 -117 91 -120 91 -3 0 -57 -41 -120 -91z m220 -10 l90 -71 0 -134 0 -134 -190 0 -190 0 0 134 0 134 87 70 c49 39 94 71 101 71 7 1 53 -31 102 -70z" />
        <path d="M188 272 c-89 -89 -99 -122 -53 -167 45 -46 78 -36 167 53 89 89 99 122 53 167 -45 46 -78 36 -167 -53z m152 38 c28 -28 25 -54 -9 -92 l-30 -33 -43 43 -43 43 33 30 c38 34 64 37 92 9z m-95 -101 l40 -40 -37 -35 c-21 -19 -47 -34 -58 -34 -26 0 -60 34 -60 60 0 18 55 90 69 90 4 0 25 -18 46 -41z" />
        <path d="M180 220 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z" />
        <path d="M150 190 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z" />
        <path d="M210 190 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z" />
        <path d="M180 160 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z" />
        <path d="M240 160 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z" />
        <path d="M150 130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z" />
        <path d="M210 130 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z" />
      </g>
    </svg>
  ),
  BillingIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="104 300 106 160"
      width="1em"
      height="1em"
      fill="currentColor"
      style={{ verticalAlign: "middle" }}
    >
      <g transform="translate(0,512) scale(0.1,-0.1)">
        <path d="M1044 1974 c-67 -33 -64 4 -64 -777 l0 -704 23 -34 c13 -19 38 -39 57 -46 45 -15 967 -18 1022 -3 20 6 48 24 62 41 l26 31 0 633 0 634 -126 113 c-69 62 -133 116 -142 120 -9 4 -199 7 -422 7 -341 0 -410 -2 -436 -15z m786 -173 c0 -140 1 -141 147 -141 l103 0 0 -569 c0 -313 -3 -576 -6 -585 -5 -14 -59 -16 -499 -16 -440 0 -494 2 -499 16 -3 9 -6 323 -6 698 0 517 3 685 12 694 9 9 107 12 380 12 l368 0 0 -109z m179 -25 l35 -36 -62 0 -62 0 0 56 0 55 28 -19 c15 -11 43 -36 61 -56z" />
        <path d="M1555 1750 c-4 -6 -26 -20 -50 -31 -52 -25 -63 -36 -71 -76 -8 -42 33 -86 111 -117 33 -13 60 -30 60 -38 0 -21 -50 -21 -94 1 -22 12 -47 18 -55 15 -41 -16 -20 -72 36 -94 18 -7 43 -23 56 -34 22 -19 25 -20 36 -5 6 10 27 24 46 32 73 30 95 94 51 141 -13 14 -52 37 -87 52 -65 28 -80 48 -44 59 13 4 34 -2 55 -15 48 -30 85 -21 85 20 0 32 -24 53 -72 65 -15 4 -29 13 -32 21 -6 16 -22 18 -31 4z" />
        <path d="M1264 1225 c-4 -8 -4 -22 0 -30 5 -13 48 -15 309 -15 259 0 306 2 317 15 10 12 10 18 0 30 -11 13 -58 15 -317 15 -261 0 -304 -2 -309 -15z" />
        <path d="M1256 1094 c-19 -19 -20 -26 -4 -42 9 -9 95 -12 324 -12 272 0 313 2 325 16 9 11 10 20 2 32 -9 15 -44 17 -321 20 -272 2 -312 0 -326 -14z" />
        <path d="M1184 955 c-4 -8 -4 -22 0 -30 5 -13 55 -15 393 -13 l388 3 0 25 0 25 -388 3 c-338 2 -388 0 -393 -13z" />
        <path d="M1177 753 c-14 -13 -7 -43 12 -53 11 -5 85 -10 170 -10 123 0 152 3 165 16 18 18 18 17 10 38 -5 14 -31 16 -178 16 -95 0 -176 -3 -179 -7z" />
        <path d="M1621 746 c-15 -18 -4 -45 23 -51 11 -3 88 -4 170 -3 124 3 151 6 159 19 6 9 7 24 4 33 -6 14 -28 16 -175 16 -132 0 -172 -3 -181 -14z" />
        <path d="M1188 649 c-24 -13 -23 -46 1 -59 27 -14 745 -14 772 0 10 6 19 19 19 30 0 11 -9 24 -19 30 -26 14 -749 13 -773 -1z" />
      </g>
    </svg>
  ),
  PtntManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width="1em"
      height="1em"
      fill="currentColor"
      style={{ verticalAlign: "middle" }}
    >
      <g
        transform="translate(0,512) scale(0.1,-0.1)"
        fill="currentColor"
        stroke="none"
      >
        <path
          d="M3823 4770 c-345 -62 -568 -401 -484 -732 20 -77 58 -163 92 -207
      l19 -24 -63 -36 c-34 -19 -101 -74 -148 -121 -69 -69 -94 -103 -131 -176 -25
      -50 -51 -114 -59 -142 l-13 -52 -318 0 c-175 0 -318 -1 -318 -2 0 -2 16 -127
      35 -278 19 -151 35 -285 35 -297 l0 -23 -184 0 -184 0 -5 258 c-5 283 -11 319
      -73 449 -64 134 -195 272 -316 334 l-37 19 29 44 c91 134 121 310 81 468 -70
      275 -301 457 -579 458 -380 1 -667 -351 -588 -720 17 -77 46 -147 85 -206 l29
      -42 -66 -39 c-217 -126 -362 -386 -362 -648 l0 -75 -150 0 -150 0 0 -1320 0
      -1320 150 0 150 0 0 420 0 420 450 0 450 0 0 -420 0 -420 150 0 150 0 0 420 0
      420 300 0 300 0 0 -420 0 -420 1510 0 1510 0 0 1170 0 1170 -149 0 -149 0 -4
      288 c-5 326 -9 347 -85 502 -39 79 -60 109 -132 180 -47 47 -114 101 -148 121
      l-63 36 19 24 c59 76 111 237 111 343 -1 259 -172 495 -414 572 -86 27 -207
      37 -283 24z m224 -322 c60 -28 113 -81 144 -144 33 -68 34 -189 1 -251 -36
      -68 -83 -114 -147 -145 -146 -69 -316 -10 -393 137 -37 70 -38 187 -3 259 41
      84 115 144 206 167 47 13 140 1 192 -23z m-2722 -66 c64 -31 111 -77 147 -145
      33 -61 32 -183 -1 -251 -32 -64 -82 -113 -150 -145 -145 -67 -319 -2 -392 145
      -35 72 -34 189 3 259 77 147 247 206 393 137z m2845 -818 c124 -28 241 -117
      296 -226 47 -93 54 -144 54 -410 l0 -248 -370 0 -370 0 -5 23 c-2 12 -18 137
      -35 277 -17 140 -33 265 -35 278 -5 22 -7 22 -180 22 -96 0 -175 2 -175 5 0 3
      12 29 26 57 53 104 187 204 304 227 81 16 413 13 490 -5z m-2691 -73 c113 -35
      203 -107 264 -211 53 -90 57 -132 57 -532 l0 -368 300 0 300 0 0 -150 0 -150
      -450 0 -450 0 0 450 0 450 -450 0 -450 0 0 68 c0 208 124 381 318 443 86 27
      473 27 561 0z m1970 -598 c6 -49 14 -116 17 -150 l7 -63 -346 0 -347 0 -4 23
      c-3 12 -10 63 -16 112 -6 50 -13 107 -16 128 l-6 37 350 0 349 0 12 -87z
      m-2249 -813 l0 -600 -450 0 -450 0 0 600 0 600 450 0 450 0 0 -600z m3620
      -570 l0 -870 -910 0 -910 0 0 360 0 360 150 0 150 0 0 -150 0 -150 150 0 150
      0 0 150 0 150 150 0 150 0 0 150 0 150 -150 0 -150 0 0 150 0 150 -150 0 -150
      0 0 -150 0 -150 -149 0 -150 0 -11 53 c-27 132 -117 252 -232 312 l-58 30 0
      163 0 162 1060 0 1060 0 0 -870z m-2194 244 c15 -11 37 -33 48 -48 20 -27 21
      -40 24 -547 l3 -519 -151 0 -150 0 0 420 0 420 -450 0 -450 0 0 150 0 150 549
      -2 c537 -3 550 -3 577 -24z"
        />
      </g>
    </svg>
  ),
  ServicesIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width="1em"
      height="1em"
      fill="currentColor"
      style={{ verticalAlign: "middle" }}
    >
      <g
        transform="translate(0,512) scale(0.1,-0.1)"
        fill="currentColor"
        stroke="none"
      >
        <path
          d="M2311 4844 c-125 -33 -254 -131 -304 -230 -56 -111 -62 -149 -61
    -409 0 -226 2 -246 26 -336 30 -111 67 -189 131 -276 42 -57 45 -64 36 -96
    -12 -45 -19 -50 -114 -85 -44 -16 -88 -33 -97 -37 -17 -7 -18 12 -18 323 0
    318 -1 330 -21 356 l-20 26 -885 0 c-871 0 -884 0 -904 -20 -20 -20 -20 -33
    -20 -569 l0 -550 26 -20 c26 -20 38 -21 360 -21 203 0 334 -4 334 -9 0 -23
    -47 -41 -105 -41 -84 0 -105 -16 -105 -80 l0 -49 -234 -3 c-298 -4 -276 11
    -276 -185 0 -130 2 -145 20 -163 12 -12 33 -20 55 -20 l35 0 0 -958 c0 -916
    1 -960 18 -975 10 -10 31 -17 45 -17 26 0 27 -3 27 -48 0 -27 7 -57 16 -70
    15 -21 21 -22 183 -22 118 0 172 4 184 12 11 9 17 31 19 68 l3 55 1716 3
    1717 2 4 -54 c7 -87 5 -86 204 -86 167 0 173 1 188 22 9 13 16 43 16 70 0 46
    1 48 28 48 60 0 62 11 62 283 l0 247 175 0 c198 0 232 8 265 62 20 33 20 47
    20 1083 0 1036 0 1050 -20 1083 -33 54 -66 62 -269 62 -179 0 -180 0 -205 25
    -14 14 -34 25 -44 25 -14 0 -21 9 -25 35 -8 47 -39 89 -81 109 -28 13 -70 16
    -230 16 -179 0 -200 -2 -237 -21 -40 -20 -78 -79 -79 -121 0 -11 -8 -18 -19
    -18 -10 0 -30 -11 -45 -25 -27 -25 -29 -25 -207 -25 -130 0 -189 -4 -213 -14
    -30 -12 -36 -12 -72 11 -99 62 -263 137 -450 207 -103 38 -121 87 -60 158 85
    99 148 272 167 461 13 127 5 336 -16 440 -36 175 -172 313 -356 362 -69 19
    -218 18 -288 -1z m301 -130 c121 -49 198 -139 224 -264 23 -112 20 -397 -5
    -518 -24 -112 -74 -218 -139 -292 -42 -48 -47 -58 -45 -99 3 -69 22 -127 57
    -166 25 -29 56 -45 161 -84 168 -62 286 -117 374 -175 l71 -46 0 -175 0 -175
    -956 0 -957 0 5 38 c3 20 16 61 28 90 l22 52 205 0 c203 0 204 0 228 25 24
    23 25 29 25 168 l0 143 53 22 c28 11 89 35 134 52 122 46 173 117 173 237 0
    32 -9 49 -51 98 -109 130 -158 299 -159 550 0 161 16 281 45 340 44 90 118
    152 222 186 74 24 214 21 285 -7z m-832 -1219 l0 -465 -300 0 -300 0 0 42 c0
    74 -9 78 -197 78 -150 0 -165 -2 -183 -20 -13 -13 -20 -33 -20 -60 l0 -40
    -300 0 -300 0 0 465 0 465 800 0 800 0 0 -465z m2588 -197 c7 -7 12 -36 12
    -64 0 -60 21 -84 73 -84 28 0 28 0 25 -57 l-3 -58 -287 -3 -288 -2 0 60 c0
    56 2 60 23 60 12 0 33 7 45 16 18 12 22 25 22 68 0 28 5 57 12 64 17 17 349
    17 366 0z m390 -1130 l2 -928 -575 0 -575 0 0 925 0 925 79 0 79 0 4 -60 c4
    -49 9 -66 31 -88 l27 -27 350 -3 349 -3 32 29 c28 25 33 37 37 90 5 69 8 71
    107 68 l50 -1 3 -927z m177 -93 l0 -1020 -752 -3 -753 -2 0 1020 0 1020 30 0
    30 0 0 -967 c0 -885 1 -968 17 -985 15 -17 49 -18 679 -18 l663 0 15 22 c14
    20 16 131 16 991 l0 968 28 -3 27 -3 0 -1020z m-3875 882 c0 -125 57 -206
    161 -226 29 -6 -57 -9 -246 -9 -159 1 -279 2 -265 5 14 2 40 6 58 9 40 6 100
    58 118 101 8 18 14 66 14 106 0 41 3 77 7 80 3 4 39 7 80 7 l73 0 0 -73z
    m251 -79 c-11 -30 -74 -37 -102 -12 -31 28 -23 34 46 34 63 0 64 -1 56 -22z
    m1997 -345 l-3 -58 -1562 -3 -1563 -2 0 60 0 60 1565 0 1566 0 -3 -57z m2
    -858 c5 -735 2 -700 66 -730 27 -13 112 -15 568 -15 l536 0 0 -205 0 -205
    -2095 0 -2095 0 0 915 0 915 1508 -2 1507 -3 5 -670z m-2770 -1285 c0 -6 -32
    -10 -75 -10 -43 0 -75 4 -75 10 0 6 32 10 75 10 43 0 75 -4 75 -10z m3840 0
    c0 -6 -32 -10 -75 -10 -43 0 -75 4 -75 10 0 6 32 10 75 10 43 0 75 -4 75
    -10z"
        />
        <path
          d="M4117 2870 c-109 -19 -233 -114 -277 -213 -84 -189 -1 -412 185
    -502 53 -26 71 -29 155 -30 84 0 102 3 157 29 77 35 153 113 191 193 23 50
    27 71 27 153 -1 83 -4 102 -28 151 -57 117 -158 196 -281 218 -65 12 -61 12
    -129 1z m160 -135 c85 -36 147 -116 159 -207 16 -116 -66 -240 -181 -274
    -212 -61 -394 152 -301 352 26 56 84 111 137 130 48 18 143 17 186 -1z"
        />
        <path
          d="M4146 2699 c-23 -18 -26 -28 -26 -80 l0 -59 -59 0 c-53 0 -62 -3
    -80 -27 -23 -28 -20 -59 7 -80 9 -7 42 -13 74 -13 l58 0 0 -60 c0 -67 21
    -100 63 -100 38 0 56 29 59 95 l3 60 60 3 c66 3 95 21 95 59 0 42 -33 63
    -100 63 l-60 0 0 64 c0 56 -3 67 -22 80 -29 21 -40 20 -72 -5z"
        />
        <path
          d="M3882 1854 c-26 -18 -30 -65 -6 -88 13 -14 64 -16 398 -16 358 0
    384 1 399 18 23 25 21 58 -3 82 -19 19 -33 20 -393 20 -321 0 -376 -2 -395
    -16z"
        />
        <path
          d="M3697 1652 c-21 -23 -22 -66 -1 -86 14 -14 72 -16 488 -16 445 0
    474 1 489 18 23 25 21 58 -3 82 -19 19 -33 20 -488 20 -442 0 -470 -1 -485
    -18z"
        />
        <path
          d="M2255 2225 c-229 -42 -429 -192 -529 -396 -63 -128 -80 -200 -79
    -334 0 -210 67 -370 218 -521 76 -76 105 -97 185 -137 52 -25 127 -54 165
    -63 90 -21 250 -21 337 0 270 63 489 282 555 554 23 96 21 256 -6 355 -98
    371 -473 611 -846 542z m270 -127 c28 -5 88 -28 134 -50 157 -75 283 -232
    327 -408 23 -89 15 -261 -16 -347 -43 -124 -131 -235 -244 -311 -109 -73
    -194 -97 -341 -97 -147 0 -232 24 -341 97 -113 76 -201 187 -244 311 -28 78
    -38 241 -21 329 21 106 82 220 164 302 160 162 358 221 582 174z"
        />
        <path
          d="M2245 1878 c-32 -18 -35 -28 -35 -120 l0 -88 -87 0 c-49 0 -93 -4
    -99 -8 -26 -17 -34 -56 -34 -170 0 -106 2 -122 21 -146 19 -25 25 -26 110
    -26 l89 0 0 -89 c0 -85 1 -91 26 -110 24 -19 40 -21 149 -21 109 0 125 2 149
    21 25 19 26 25 26 110 l0 89 89 0 c86 0 91 1 111 27 20 26 21 37 18 161 -4
    164 -2 162 -130 162 l-88 0 0 88 c0 128 2 126 -162 130 -88 1 -140 -2 -153
    -10z m195 -205 c0 -117 6 -123 122 -123 l88 0 0 -55 0 -55 -87 0 c-117 0
    -123 -6 -123 -122 l0 -88 -55 0 -55 0 0 89 c0 117 -4 121 -121 121 l-89 0 0
    55 0 55 87 0 c117 0 123 6 123 122 l0 88 55 0 55 0 0 -87z"
        />
      </g>
    </svg>
  ),
  RadiologyIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="currentColor"
      style={{ verticalAlign: "middle" }}
    >
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M12 5.5c-1.2 0-2.3.4-3.2 1.1l1.5 1.5c.5-.4 1.1-.6 1.7-.6.6 0 1.2.2 1.7.6l1.5-1.5c-.9-.7-2-1.1-3.2-1.1zM7.1 9.3l1.5 1.5c-.4.5-.6 1.1-.6 1.7 0 .6.2 1.2.6 1.7l-1.5 1.5c-.7-.9-1.1-2-1.1-3.2 0-1.2.4-2.3 1.1-3.2zM16.9 9.3c.7.9 1.1 2 1.1 3.2 0 1.2-.4 2.3-1.1 3.2l-1.5-1.5c.4-.5.6-1.1.6-1.7 0-.6-.2-1.2-.6-1.7l1.5-1.5zM12 16.5c-.6 0-1.2-.2-1.7-.6l-1.5 1.5c.9.7 2 1.1 3.2 1.1s2.3-.4 3.2-1.1l-1.5-1.5c-.5.4-1.1.6-1.7.6z" />
    </svg>
  ),
};
